/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { TextAreaField } from 'components/form'
import { MetaPath } from 'util/metaPath'

interface ResultadoExameTextAreaFieldProps {
  name: MetaPath<string> | string
}

export const ResultadoExameTextAreaField = (props: ResultadoExameTextAreaFieldProps) => {
  const { name } = props

  return (
    <TextAreaField
      name={name}
      placeholder='Clique para inserir o resultado...'
      maxLength={2000}
      style={css`
        resize: vertical;
      `}
    />
  )
}
